import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './MicroSoudurePlasturgie.css';

import microSoudurePlasturgieImage from '../images/Microsoudure-et-réparation-plastique-à-Nantes.webp';
import microSoudurePlasturgieImage2 from '../images/UPGRADE-INFORMATIQUE-3-1.webp';

const MicroSoudurePlasturgie = () => {
  return (
    <>
      <Helmet>
        <title>Expert en microsoudure et réparation plastique d'ordinateurs à Rezé, région nantaise</title>
        <meta name="description" content="Expert en microsoudure et réparation plastique d'ordinateurs à Rezé, région nantaise. Charnières cassées, coques endommagées, ports USB défectueux, connectiques HDMI." />
        <meta name="keywords" content="microsoudure, réparation plastique, ordinateurs, Rezé, Nantes, charnières cassées, ports USB, connectiques HDMI, Upgrade Informatique" />
      </Helmet>
      
      <div className="page-content">
        <div className="container">
          <article className="page-article">
            <div className="entry-content">
              <h1>Expert en microsoudure et réparation plastique d'ordinateurs à Rezé, région nantaise</h1>
              
              <h2>Une expertise technique approfondie pour répondre à tous vos besoins</h2>
              
              <p>
                Face aux défis techniques régulièrement rencontrés, <strong><Link to="/">Upgrade Informatique</Link></strong> a développé une expertise pointue en microsoudure et <Link to="/blog/carte-mere-morte-5-signes-solutions-2025" className="blog-link"><strong>réparation plastique</strong></Link> pour résoudre efficacement les dommages accidentels les plus complexes : charnières cassées, coques endommagées, ports USB défectueux, connectiques HDMI abîmées ou prises d'alimentation défaillantes.
              </p>

              <p>
                Notre service comprend une prise en charge complète à votre domicile, incluant un <Link to="/blog/reparation-carte-mere-vraiment-possible-tests-tarifs" className="blog-link"><strong>diagnostic approfondi</strong></Link> et une livraison personnalisée après réparation. Notre engagement : vous garantir une intervention professionnelle et sur mesure.
              </p>

              <p>
                Chez Upgrade Informatique, nous plaçons la <strong>relation de confiance</strong> au cœur de nos priorités. Nous vous proposons systématiquement les <Link to="/blog/carte-mere-hs-reparer-ou-remplacer-verdict-2025" className="blog-link"><strong>solutions de réparation les plus pertinentes</strong></Link> et économiques pour votre équipement.
              </p>

              <div className="images-grid">
                <div className="image-item">
                  <img 
                    src={microSoudurePlasturgieImage} 
                    alt="Upgrade Informatique - Microsoudure et réparation plastique"
                    className="content-image"
                  />
                </div>
                
                <div className="image-item">
                  <img 
                    src={microSoudurePlasturgieImage2} 
                    alt="Upgrade Informatique - Expertise technique"
                    className="content-image"
                  />
                </div>
              </div>

              <p>
                Besoin de renseignements complémentaires sur nos services ?
              </p>

              <div className="contact-cta">
                <h2>Besoin d'une réparation en microsoudure ou plasturgie ?</h2>
                <p>Expertise technique pointue pour dommages complexes</p>
                <p>Contactez Upgrade Informatique au <Link to="/contact" className="phone-link">Contactez-nous</Link></p>
                <Link to="/contact" className="btn btn-primary">Obtenir un devis personnalisé</Link>
              </div>
            </div>
          </article>
        </div>
      </div>
    </>
  );
};

export default MicroSoudurePlasturgie;
